import { Layout } from "../../../components/Layout";
import { Column, Grid, Row } from "carbon-components-react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Sidebar from "../../../components/simple/sidebar";
import IntroductionContent from "./introduction-content";
import CertificateCreation from "./certificate-creation";
import RequestFormat from "./request-format";
import Xml from "./xml";
import Json from "./json";
import RequestforQuasiCashPurchase from "./request-quasi-cash";
import PreauthorizationSoap from "./preauthorization-xml";
import PreauthorizationJson from "./preauthorization-json";
import PreauthorizationXml from "./preauthorization-xml";
import CompletionXml from "./completion-xml";
import CompletionJson from "./completion-json";
import PaymentReversalXml from "./paymentreversal-xml";
import PaymentReversalJson from "./paymentreversal-json";
import PartialReversalJson from "./partialreversal-json";
import RefundXml from "./refundl-xml";
import RefundJson from "./refund-json";
import GetOrderDetailsJson from "./getorder-details-json";

import P2PCreditJson from "./p2pcredit-json";
import SecurePaymentAuthenticationlXml from "./authentication-xml";
import RecurrentPaymentMITJson from "./recurrent-payment-mit-json";
import SecurePaymentAuthenticationlJson from "./authentication-json";
import RecurrentPaymentCITJson from "./recurrent-payment-cit-json";
import CardToCardTransferTXPGAPIJson from "./card-to-card-transfer-json";
import C2CTransferJson from "./c2c-transfer-json";
import Error from "./error";
import ApplePay from "./apple-pay";
import GooglePay from "./google-pay";

export default function TechnicalDocument() {
  const { pathname } = useLocation();

  return (
    <Layout>
      <main className="container technical-document-container">
        <Grid>
          <Row>
            <Column lg={12}>
              <div className="technical-document">
                <div className="td-left">
                  <Sidebar />
                </div>
                <div className="td-right">
                  {pathname ===
                    "/e-commerce/technical-document-pages/technical-document" && (
                    <IntroductionContent />
                  )}

                  <Routes>
                    <Route
                      path="certificate-creation"
                      element={<CertificateCreation />}
                    />
                    <Route path="request-format" element={<RequestFormat />} />
                    <Route path="xml" element={<Xml />} />
                    <Route path="json" element={<Json />} />
                    <Route
                      path="request-quasi-cash"
                      element={<RequestforQuasiCashPurchase />}
                    />
                    <Route
                      path="preauthorization-xml"
                      element={<PreauthorizationXml />}
                    />
                    <Route
                      path="preauthorization-json"
                      element={<PreauthorizationJson />}
                    />
                    <Route path="completion-xml" element={<CompletionXml />} />
                    <Route
                      path="completion-json"
                      element={<CompletionJson />}
                    />
                    <Route
                      path="payment-reversal-xml"
                      element={<PaymentReversalXml />}
                    />
                    <Route
                      path="payment-reversal-json"
                      element={<PaymentReversalJson />}
                    />
                    <Route
                      path="partial-reversal-json"
                      element={<PartialReversalJson />}
                    />
                    <Route path="refund-xml" element={<RefundXml />} />
                    <Route path="refund-json" element={<RefundJson />} />
                    <Route
                      path="get-order-details-json"
                      element={<GetOrderDetailsJson />}
                    />
                    <Route
                      path="recurrent-payment-mit-json"
                      element={<RecurrentPaymentMITJson />}
                    />
                    <Route
                      path="authentication-xml"
                      element={<SecurePaymentAuthenticationlXml />}
                    />
                    <Route
                      path="authentication-json"
                      element={<SecurePaymentAuthenticationlJson />}
                    />
                    <Route
                      path="recurrent-payment-cit-json"
                      element={<RecurrentPaymentCITJson />}
                    />
                    <Route path="p2pcedit-json" element={<P2PCreditJson />} />
                    <Route
                      path="card-to-card-transfer-json"
                      element={<CardToCardTransferTXPGAPIJson />}
                    />

                    <Route
                      path="c2c-transfer-json"
                      element={<C2CTransferJson />}
                    />
                    <Route
                      path="error"
                      element={<Error />}
                    />
                     <Route
                      path="apple-pay"
                      element={<ApplePay />}
                    />
                     <Route
                      path="google-pay"
                      element={<GooglePay />}
                    />
                  </Routes>
                </div>
              </div>
            </Column>
          </Row>
        </Grid>
      </main>
    </Layout>
  );
}
